export default async (_, { value }, context) => {
	context.client.writeData({ data: { saver: value } });

	return;
};
